const s = {
  name: "CreditCard2",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M29,21h6v-2h-6V21z"/>
		<path class="st0" d="M27,21h-6v-2h6V21z"/>
		<path class="st0" d="M13,21h6v-2h-6V21z"/>
		<path class="st0" d="M11,21H5v-2h6V21z"/>
		<path class="st0" d="M12,9H5v7h7V9z M7,14v-3h3v3H7z"/>
		<path class="st0" d="M5,0C2.2,0,0,2.2,0,5v16c0,2.8,2.2,5,5,5h30c2.8,0,5-2.2,5-5V5c0-2.8-2.2-5-5-5H5z M2,5c0-1.7,1.3-3,3-3h30
			c1.7,0,3,1.3,3,3v16c0,1.7-1.3,3-3,3H5c-1.7,0-3-1.3-3-3V5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CreditCard2
};
